import { subscriptionData } from '../../contracts';

export const subscriptionAbi = subscriptionData.abi;
